const { TYPES } = require("./payment_withdraw.type");

const initState = {
  paymentWithdrawAll: null,
  //
  paymentWithdrawBanks: null,
  paymentWithdrawCode: null,
  paymentWithdrawSearch: "",
  //
  paymentWithdrawLast: null,
};

const paymentWithdrawReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.SET_PAYMENT_WITHDRAW_ALL:
      return {
        ...state,
        paymentWithdrawAll: payload,
      };

    //

    case TYPES.SET_PAYMENT_WITHDRAW_BANKS:
      return {
        ...state,
        paymentWithdrawBanks: payload,
      };

    case TYPES.SET_PAYMENT_WITHDRAW_CODE:
      return {
        ...state,
        paymentWithdrawCode: payload,
      };

    case TYPES.SET_PAYMENT_WITHDRAW_SEARCH:
      return {
        ...state,
        paymentWithdrawSearch: payload,
      };

    case TYPES.SET_PAYMENT_WITHDRAW_LAST:
      return {
        ...state,
        paymentWithdrawLast: payload,
      };

    default:
      return state;
  }
};

export default paymentWithdrawReducer;
